<div style="padding: 16px">
  <!-- Info: mitä tietoja LLM saa -->
  <details style="background: #f5f5f5; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px 16px; margin-bottom: 16px">
    <summary style="cursor: pointer; font-weight: 500; font-size: 13px">Mitä tietoja LLM:lle lähetetään?</summary>
    <div style="margin-top: 10px; font-size: 13px; color: #444">
      <p style="margin: 0 0 8px">Jokaisen testitapauksen mukana LLM saa seuraavat tiedot:</p>
      <ul style="margin: 0 0 8px 20px; padding: 0">
        <li><strong>Asiakkaan perustiedot</strong>: nimi, toiminnan kuvaus, kirjanpidon peruste (suorite-/maksuperuste)</li>
        <li><strong>YTJ-tiedot</strong>: toiminimi, yritysmuoto, päätoimiala</li>
        <li><strong>Asiakkaan käyttämät maksutavat</strong> ja niiden oletusvastatilit</li>
        <li><strong>Verojen maksun viitenumerot</strong>: yleinen viite, oma-aloitteiset verot, yhteisön tulovero, henkilön tulovero</li>
        <li><strong>Asiakkaan tilikartta</strong>: aktiiviset tilit numeroineen, nimineen ja oletus-ALV-käsittelyineen</li>
        <li><strong>Aiemmat kirjaukset samalle saajalle tai maksajalle</strong> esimerkkeinä: päivämäärä, summa, käytetyt tilit ja ALV-tunnisteet</li>
        <li><strong>Käsiteltävän kirjauksen tiedot</strong>: kirjausnumero, päivämäärä, summa, saaja/maksaja, viitenumero, pankin viesti, Lemonaidin viesti, kommentti</li>
        <li><strong>Liitetyn laskun tiedot</strong> (jos kirjaus liittyy laskuun): laskun numero, päivämäärä, eräpäivä, summa, ALV 0, avoinna, valuutta, viitenumero, tuoterivit (nimi, määrä, hinta, ALV-%)</li>
        <li><strong>Liitettyjen tositteiden tiedot</strong>: selite, summa, lähde</li>
        <li><strong>Tositekuvat ja PDF-liitteet</strong></li>
        <li><strong>Asiakaskohtaiset lisäohjeet</strong> (jos asetettu)</li>
        <li><strong>Yleinen ohjeistus ja kategoriakohtaiset säännöt</strong> kirjausten ja ALV-käsittelyn tekemiseksi (versioidut)</li>
      </ul>
    </div>
  </details>

  <!-- Aloita-palkki -->
  <div style="display: flex; gap: 8px; align-items: flex-end; margin-bottom: 16px; padding: 12px; background: #fafafa; border-radius: 4px">
    <mat-form-field style="flex: 1">
      <mat-label>Setti</mat-label>
      <mat-select [formField]="ajoSettiKentta" [compareWith]="vertaileSetit">
        @for (s of setit; track s.avain) {
          <mat-option [value]="s">{{ s.nimi }} ({{ s.testitapausLkm }} kpl)</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field style="width: 220px">
      <mat-label>Malli</mat-label>
      <mat-select [formField]="malliKentta" [compareWith]="vertaileMallit">
        @for (m of mallit; track m.malli) {
          <mat-option [value]="m">{{ m.malli }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-primary-button (click)="aloitaTestiAjo.emit()" [disabled]="!valittuAjoSetti || testiajoKaynnissa" style="margin: auto" actionId="Aloita LLM-testiajo">
      @if (testiajoKaynnissa) {
        <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
      }
      Aloita testiajo
    </app-primary-button>
  </div>

  @if (testiajotLataa) {
    <mat-spinner diameter="32"></mat-spinner>
  }
  @if (!testiajotLataa && !testiajot.length) {
    <p style="color: #888">Ei testiajoja tälle kategorialle.</p>
  }

  @if (!testiajotLataa && testiajot.length) {
    <mat-accordion>
      @for (testiajo of testiajot; track testiajo.avain) {
        <mat-expansion-panel (opened)="testiajoPaneelAuki.emit(testiajo)" (closed)="testiajoPaneelKiinni.emit(testiajo.avain)">
          <mat-expansion-panel-header>
            <mat-panel-title style="align-items: center; gap: 8px">
              @if (testiajo.tila === 'kaynnissa') {
                <mat-spinner diameter="16"></mat-spinner>
              }
              @if (testiajo.tila === 'valmis') {
                <mat-icon style="color: #4caf50; font-size: 20px; width: 20px; height: 20px">check_circle</mat-icon>
              }
              @if (testiajo.tila === 'virhe') {
                <mat-icon style="color: #f44336; font-size: 20px; width: 20px; height: 20px">cancel</mat-icon>
              }
              {{ testiajo.aloitettu | date: 'dd.MM.yyyy HH:mm' }} — {{ testiajo.malli ?? testiajo.tarjoaja }}
              @if (testiajo.testisettiNimi && testiajo.testisettiAvain) {
                <span style="margin-left: 8px; font-size: 11px; color: #555">Testisetti: {{ testiajo.testisettiNimi }}</span>
              }
              @if (testiajo.testisettiNimi && !testiajo.testisettiAvain) {
                <span style="margin-left: 8px; font-size: 11px; color: #999; text-decoration: line-through" matTooltip="Setti on poistettu">setti: {{ testiajo.testisettiNimi }} (poistettu)</span>
              }
            </mat-panel-title>
            @if (testiajo.tila === 'kaynnissa' && testiajo.kirjauksia) {
              <mat-panel-description> {{ kasiteltyLkm.get(testiajo.avain) ?? 0 }} / {{ testiajo.kirjauksia }} käsitelty </mat-panel-description>
            }
            @if (testiajo.tila === 'valmis') {
              <mat-panel-description>
                {{ testiajo.kirjauksia }} kpl &nbsp;|&nbsp; Tili {{ testiajo.tiliTarkkuusProsentti !== null ? (testiajo.tiliTarkkuusProsentti | number: '1.1-1') + '%' : '—' }} &nbsp;|&nbsp; ALV {{ testiajo.alvTarkkuusProsentti !== null ? (testiajo.alvTarkkuusProsentti | number: '1.1-1') + '%' : '—' }} &nbsp;|&nbsp; Täydelliset
                {{ taydellisetProsentti(testiajo) !== null ? (taydellisetProsentti(testiajo) | number: '1.1-1') + '%' : '—' }}
              </mat-panel-description>
            }
          </mat-expansion-panel-header>

          <!-- Käynnissä-tila -->
          @if (testiajo.tila === 'kaynnissa') {
            <div style="margin-bottom: 16px">
              <p style="font-size: 13px; color: #555; margin: 0 0 8px">Testiajo on käynnissä...</p>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }

          <!-- Virhe-tila -->
          @if (testiajo.tila === 'virhe') {
            <div style="margin-bottom: 16px">
              <div style="border: 1px solid #f44336; background: #ffebee; border-radius: 4px; padding: 12px">
                <div style="font-weight: 500; color: #c62828; margin-bottom: 8px; display: flex; align-items: center; gap: 6px">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px">error_outline</mat-icon>
                  Testiajo päättyi virheeseen
                </div>
                @if (testiajo.virheViesti) {
                  <pre style="margin: 0; font-size: 11px; white-space: pre-wrap; word-break: break-word; max-height: 240px; overflow-y: auto; color: #444">{{ testiajo.virheViesti }}</pre>
                } @else {
                  <p style="margin: 0; font-size: 12px; color: #666">Virheviestiä ei tallennettu (ajo ennen tämän ominaisuuden käyttöönottoa). Tarkista Cloud Functions -lokit.</p>
                }
              </div>
            </div>
          }

          <!-- Yhteenveto -->
          @if (testiajo.tila === 'valmis') {
            <div style="margin-bottom: 16px">
              <table style="border-collapse: collapse; font-size: 13px">
                <tr>
                  <td style="padding: 4px 12px 4px 0">Käsitelty:</td>
                  <td>
                    <strong>{{ testiajo.kirjauksia }}</strong>
                  </td>
                  <td style="padding: 4px 12px 4px 16px">Onnistuneita:</td>
                  <td>
                    <strong>{{ testiajo.onnistuneita }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Tilitarkkuus:</td>
                  <td>
                    <strong>{{ testiajo.tiliTarkkuusProsentti !== null ? (testiajo.tiliTarkkuusProsentti | number: '1.1-1') + '%' : '—' }}</strong>
                  </td>
                  <td style="padding-left: 16px">Suuntatarkkuus:</td>
                  <td>
                    <strong>{{ testiajo.suuntaTarkkuusProsentti !== null ? (testiajo.suuntaTarkkuusProsentti | number: '1.1-1') + '%' : '—' }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Summatarkkuus:</td>
                  <td>
                    <strong>{{ testiajo.summaTarkkuusProsentti !== null ? (testiajo.summaTarkkuusProsentti | number: '1.1-1') + '%' : '—' }}</strong>
                  </td>
                  <td style="padding-left: 16px">ALV-tarkkuus:</td>
                  <td>
                    <strong>{{ testiajo.alvTarkkuusProsentti !== null ? (testiajo.alvTarkkuusProsentti | number: '1.1-1') + '%' : '—' }}</strong>
                  </td>
                </tr>
                <tr>
                  <td>Täydelliset osumat:</td>
                  <td>
                    <strong>{{ testiajo.taydellisetOsumat }}</strong>
                  </td>
                  <td style="padding-left: 16px">Tokenit (in/out):</td>
                  <td>
                    <strong>{{ testiajo.yhteensaInputTokenit }} / {{ testiajo.yhteensaOutputTokenit }}</strong>
                  </td>
                </tr>
              </table>
            </div>
          }

          <!-- Prompt -->
          @if (testiajo.globaaliSystemPrompt || testiajo.kategoriaSystemPrompt || testiajo.jsonKontrakti) {
            <div style="margin-bottom: 16px">
              <app-button (click)="togglePrompt.emit(testiajo.avain)" styles="padding-left: 0" [matIcon]="naytaPrompttiAvaimet.has(testiajo.avain) ? 'expand_less' : 'expand_more'" actionId="Näytä/piilota LLM-promptit">
                {{ naytaPrompttiAvaimet.has(testiajo.avain) ? 'Piilota promptit' : 'Näytä promptit (snapshot)' }}
              </app-button>
              @if (naytaPrompttiAvaimet.has(testiajo.avain)) {
                <div style="margin-top: 8px">
                  @if (testiajo.jsonKontrakti) {
                    <div style="font-size: 12px; color: #1976d2; font-family: monospace; margin-bottom: 4px">Vastausrakenne (kovakoodattu)</div>
                    <pre style="background: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; padding: 12px; font-size: 11px; white-space: pre-wrap; word-break: break-word; max-height: 500px; overflow-y: auto; margin: 0 0 12px">{{ testiajo.jsonKontrakti }}</pre>
                  }
                  @if (testiajo.globaaliSystemPrompt) {
                    <div style="font-size: 12px; color: #1976d2; font-family: monospace; margin-bottom: 4px">
                      Globaali prompt
                      @if (testiajo.globaaliPromptVersio !== null) {
                        v{{ testiajo.globaaliPromptVersio }}
                      }
                    </div>
                    <pre style="background: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; padding: 12px; font-size: 11px; white-space: pre-wrap; word-break: break-word; max-height: 500px; overflow-y: auto; margin: 0 0 12px">{{ testiajo.globaaliSystemPrompt }}</pre>
                  }
                  @if (testiajo.kategoriaSystemPrompt) {
                    <div style="font-size: 12px; color: #1976d2; font-family: monospace; margin-bottom: 4px">
                      Kategoriaprompt ({{ testiajo.kategoria }})
                      @if (testiajo.kategoriaPromptVersio !== null) {
                        v{{ testiajo.kategoriaPromptVersio }}
                      }
                    </div>
                    <pre style="background: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; padding: 12px; font-size: 11px; white-space: pre-wrap; word-break: break-word; max-height: 500px; overflow-y: auto; margin: 0">{{ testiajo.kategoriaSystemPrompt }}</pre>
                  }
                  <div style="font-size: 12px; color: #1976d2; font-family: monospace; margin: 12px 0 4px">Tilisarjat</div>
                  @if (testiajo.tilikarttaRajat.length) {
                    <div style="font-size: 12px; font-family: monospace">
                      @for (raja of testiajo.tilikarttaRajat; track $index) {
                        <span style="display: inline-block; background: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; padding: 2px 8px; margin: 0 6px 6px 0">{{ raja.alkaa }}–{{ raja.loppuu }}</span>
                      }
                    </div>
                  } @else {
                    <div style="font-size: 12px; color: #666">Koko tilikartta</div>
                  }
                </div>
              }
            </div>
          }

          <!-- Tulokset -->
          @if (tuloksetTestiajoAvain === testiajo.avain) {
            <div>
              @if (tuloksetLataa) {
                <div>
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
              }
              @if (!tuloksetLataa && tuloksetSorted.length) {
                <div>
                  <app-button (click)="lataaTuloksetExcelina()" styles="margin-bottom: 8px" matIcon="download" actionId="Lataa LLM-testitulokset Exceliin">Lataa Excel</app-button>
                  <div style="overflow-x: auto">
                    <table mat-table [dataSource]="tuloksetSorted" matSort (matSortChange)="onTulosSortMuuttui($event)" multiTemplateDataRows class="mat-elevation-z1" style="width: 100%; min-width: 1100px; font-size: 12px">
                      <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef style="width: 32px"></th>
                        <td mat-cell *matCellDef="let t" style="width: 32px">
                          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #777; vertical-align: middle">{{ avattuTulos === t ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="asiakas">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Asiakas</th>
                        <td mat-cell *matCellDef="let t">{{ t.asiakasNimi }}</td>
                      </ng-container>
                      <ng-container matColumnDef="kirjausnumero">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Kirjausnumero</th>
                        <td mat-cell *matCellDef="let t">{{ t.kirjausnumero }}</td>
                      </ng-container>
                      <ng-container matColumnDef="saajaLisatieto">
                        <th mat-header-cell *matHeaderCellDef>Saaja / lisätieto</th>
                        <td mat-cell *matCellDef="let t">
                          @if (t.maksunSaaja) {
                            <div>{{ t.maksunSaaja }}</div>
                          }
                          @if (t.asiakkaanLisatieto) {
                            <div style="color: #777; font-size: 11px">{{ t.asiakkaanLisatieto }}</div>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="kategoria">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Kategoria</th>
                        <td mat-cell *matCellDef="let t">
                          @if (t.kategoria) {
                            <span style="font-family: monospace; font-size: 11px">{{ t.kategoria }}</span>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="todellisetTilit">
                        <th mat-header-cell *matHeaderCellDef>Todelliset tilit</th>
                        <td mat-cell *matCellDef="let t">{{ t.todellisetTilit.join(', ') }}</td>
                      </ng-container>
                      <ng-container matColumnDef="ehdotetutTilit">
                        <th mat-header-cell *matHeaderCellDef>Ehdotetut tilit</th>
                        <td mat-cell *matCellDef="let t">{{ t.ehdotetutTilit.join(', ') }}</td>
                      </ng-container>
                      <ng-container matColumnDef="todellinenAlv">
                        <th mat-header-cell *matHeaderCellDef>Todellinen alv</th>
                        <td mat-cell *matCellDef="let t">{{ t.todellisetAlv.join(', ') }}</td>
                      </ng-container>
                      <ng-container matColumnDef="ehdotetutAlv">
                        <th mat-header-cell *matHeaderCellDef>Ehdotetut alv</th>
                        <td mat-cell *matCellDef="let t">{{ t.ehdotetutAlv.join(', ') }}</td>
                      </ng-container>
                      <ng-container matColumnDef="osumat">
                        <th mat-header-cell *matHeaderCellDef>Tiliosumat</th>
                        <td mat-cell *matCellDef="let t">{{ t.osumatLkm }}/{{ t.todellisetTilit.length }}</td>
                      </ng-container>
                      <ng-container matColumnDef="alvOsumat">
                        <th mat-header-cell *matHeaderCellDef>ALV-osumat</th>
                        <td mat-cell *matCellDef="let t">{{ t.alvOsumatLkm }}/{{ t.todellisetTilit.length }}</td>
                      </ng-container>
                      <ng-container matColumnDef="kaikkiOikein">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Kaikki oikein</th>
                        <td mat-cell *matCellDef="let t">
                          @if (kaikkiOikein(t)) {
                            <span style="color: #2e7d32; font-weight: 500">Kyllä</span>
                          } @else {
                            <span style="color: #c62828">Ei</span>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="confidence">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Confidence</th>
                        <td mat-cell *matCellDef="let t">{{ t.confidenceLevel !== null ? t.confidenceLevel : '—' }}</td>
                      </ng-container>
                      <ng-container matColumnDef="virhe">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 300px">Virhe</th>
                        <td mat-cell *matCellDef="let t" style="color: #c00; min-width: 300px; white-space: pre-wrap; word-break: break-word">{{ t.ehdotusVirhe }}</td>
                      </ng-container>
                      <ng-container matColumnDef="perusteluDetail">
                        <td mat-cell *matCellDef="let t" [attr.colspan]="tulosColumns.length" style="padding: 0">
                          <div style="padding: 12px 16px; max-width: 900px">
                            <div style="font-size: 14px; color: #1976d2; margin-bottom: 4px">Tekoälyn perustelu</div>
                            @if (t.perustelu) {
                              <span style="margin: 0; font-size: 14px; white-space: pre-wrap; word-break: break-word">{{ t.perustelu }}</span>
                            } @else {
                              <span style="font-size: 14px; color: #888">Ei perustelua.</span>
                            }
                          </div>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="tulosColumns"></tr>
                      <tr mat-row *matRowDef="let t; columns: tulosColumns" (click)="toggleTulosRivi(t)" style="cursor: pointer"></tr>
                      <tr mat-row *matRowDef="let t; columns: ['perusteluDetail']; when: onkoTulosRiviAuki" style="height: auto"></tr>
                    </table>
                  </div>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
